import { Box, Typography, Skeleton } from "@mui/material";
import cardBg from '../../../src/assets/images/background/opCardBg.png'
import { useMemo } from "react";

const PatientDetailsStats = ({ dashboardData, loading: parentLoading }) => {
  //@info getting the data from the parent component.
  const excludedKeys = [
  "recent_activity",
  "total_phase",
  "total_patient",
  "phase_statistics",
];

const recentActivityCRData = useMemo(() => {
  if (!dashboardData) return [];

  return Object.entries(dashboardData)
    .filter(([key, value]) =>
      !excludedKeys.includes(key) && typeof value === "number"
    )
    .map(([key, count]) => ({
      label: key
        .replaceAll("_", " ")
        .replace(/^./, (char) => char.toUpperCase()),
      value: count,
    }));
}, [dashboardData]);

const fullCapsWords = ["lsm","bmr","cdm"];

const formatLabel = (str) => {
  if (!str) return "";

  return str
    .split(" ")
    .map(word => {
      if (fullCapsWords.includes(word.toLowerCase())) {
        return word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        padding: "16px 24px",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.04)",
        mt: 2,
      }}
    >
      <Typography variant="h6" fontWeight={600} mb={2}>
        Patient Details
      </Typography>

      {/* Cards Row */}
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          overflowX: "auto",
          paddingBottom: "8px",
          "&::-webkit-scrollbar": { height: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#E0E0E0",
            borderRadius: "8px",
          },
        }}
      >
        {parentLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  minWidth: "180px",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #E6EEF8",
                  backgroundColor: "#F9FBFF",
                  flexShrink: 0,
                }}
              >
                <Skeleton variant="text" width={60} height={42} />
                <Skeleton variant="text" width="80%" height={20} />
              </Box>
            ))
          : recentActivityCRData?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  minWidth: "180px",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #E6EEF8",
                  backgroundImage: `url(${cardBg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right bottom",
                  backgroundSize: "contain",
                  backgroundColor: "#F9FBFF",
                  flexShrink: 0,
                }}
              >
                <Typography variant="h4" fontWeight={700} color="#000" gutterBottom>
                  {item.value}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  {formatLabel(item.label)}
                </Typography>
              </Box>
            ))}
      </Box>
    </Box>
  );
};

export default PatientDetailsStats;
